import React, { useState } from 'react';
import VForm from 'react-validation/build/form';
import VButton from 'react-validation/build/button';
import validator from 'validator';

import instapayIcon from './../../../../../../statics/img/instapay/instapay_icon.png';
import '../Instapay.css';
import RequestPay from '../RequestPay';
import { PAYMENT_METHODS } from '../Instapay';
import { Input } from '../Input';
import { msToTime } from '../../../../../../utils/msToTime';

export const COLLECT_INPUTS = {
  INSTAPAY_ID: 'ID',
  MOBILE_NUMBER: 'Mobile number',
};

function CollectMethod(props) {
  const {
    onPay,
    isRequestPay,
    onInquiry,
    isInquiring,
    children,
    timer,
    isLoading,
    onOpenCancelModal,
    paymentData,
  } = props;
  const [selectedInput, setSelectedInput] = useState(
    COLLECT_INPUTS.INSTAPAY_ID
  );
  const [inputValue, setInputValue] = useState('');
  const [hasError, setHasError] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const requiredV = (value, props) => {
    setHasError(false);
    if (validator.isEmpty(value)) {
      if (props.isChanged) setHasError(true);
      return (
        // We can return string or jsx as the 'error' prop for the validated Component
        <div className="alert alert-danger" role="alert">
          This field is required.
        </div>
      );
    }
  };

  const phoneNumberV = (value, props) => {
    setHasError(false);
    const isValidNumber = /^\d{10}$/.test(value.trim());
    if (!isValidNumber) {
      if (props.isChanged) setHasError(true);
      return (
        // We can return string or jsx as the 'error' prop for the validated Component
        <div className="alert alert-danger" role="alert">
          Invalid mobile number.
        </div>
      );
    }
  };

  const instapayIDV = (value, props) => {
    setHasError(false);
    const regex = /^[a-zA-Z0-9]+@instapay$/;
    const isValidID = regex.test(value.trim());
    if (!isValidID) {
      if (props.isChanged) setHasError(true);
      return (
        // We can return string or jsx as the 'error' prop for the validated Component
        <div className="alert alert-danger" role="alert">
          Invalid instapay id.
        </div>
      );
    }
  };

  const handleOnSelectInput = (item) => {
    setSelectedInput(item);
    setInputValue('');
    setShowDropdown(false);
  };

  const handleInputOnChange = (e) => setInputValue(e.target.value.trim());

  const handleToggleDropdown = () => setShowDropdown((prevState) => !prevState);

  const handleSubmit = (e) => {
    e.preventDefault();

    const collectInputValue =
      COLLECT_INPUTS.INSTAPAY_ID === inputValue ? inputValue : '0' + inputValue;

    onPay(PAYMENT_METHODS.COLLECT, collectInputValue);
  };

  if (!isRequestPay) {
    return (
      <VForm
        key={selectedInput}
        onSubmit={handleSubmit}
        className="instapay_form"
      >
        <div className="instapay_cardinfo">
          <label className="instapay_label">Instapay ID / Mobile Number</label>
          <Input
            name={selectedInput}
            value={inputValue}
            onChange={handleInputOnChange}
            validations={[
              requiredV,
              ...(selectedInput === COLLECT_INPUTS.INSTAPAY_ID
                ? [instapayIDV]
                : [phoneNumberV]),
            ]}
            placeholder={
              selectedInput === COLLECT_INPUTS.INSTAPAY_ID
                ? 'ex. Youssef@instapay'
                : '00 000 000 00'
            }
            currentInput={selectedInput}
            onSelectInput={handleOnSelectInput}
            options={Object.values(COLLECT_INPUTS)}
            hasError={hasError}
            maxLength={
              selectedInput === COLLECT_INPUTS.MOBILE_NUMBER ? 10 : null
            }
            onToggleDropdown={handleToggleDropdown}
            showDropdown={showDropdown}
          />
        </div>
        {children}
        <VButton
          disabled={isLoading}
          className="instapay_btn instapay_btn_main instapay_btn_pay"
        >
          Pay
        </VButton>
      </VForm>
    );
  }

  return (
    <RequestPay
      onInquiry={onInquiry}
      isInquiring={isInquiring}
      isLoading={isLoading}
      onOpenCancelModal={onOpenCancelModal}
    >
      <img
        src={instapayIcon}
        alt="instapay"
        className="instapay_request_header_logo"
      />
      <p className="instapay_request_header_title">Request to pay</p>
      <div className="instapay_request_header_support">
        <p className="instapay_request_header_support-light-text instapay_mb-2">
          You will receive a request to Pay an amount of EGP{' '}
          {parseFloat(paymentData.data.amount)}
          <br />
          Please authorize the Payment using Instapay Mobile Application
        </p>
        <p className="instapay_request_header_support-light-text">
          Please complete the transaction in{' '}
          <span className="instapay_highlight">{msToTime(timer)}</span>{' '}
          {timer < 60000 ? 'seconds' : 'minutes'}
        </p>
      </div>
    </RequestPay>
  );
}

export default CollectMethod;
